import config from '../../../constants/global-unreads-count.config';
import ConnectivityService from '../../../services/connectivity.service';
export default (function (_a) {
    var store = _a.store, selector = _a.selector, chatroomsActions = _a.chatroomsActions, globalUnreadsCountActions = _a.globalUnreadsCountActions;
    return new GlobalUnreadsCountApi({ store: store, selector: selector, chatroomsActions: chatroomsActions, globalUnreadsCountActions: globalUnreadsCountActions });
});
var GlobalUnreadsCountApi = /** @class */ (function () {
    function GlobalUnreadsCountApi(_a) {
        var store = _a.store, selector = _a.selector, chatroomsActions = _a.chatroomsActions, globalUnreadsCountActions = _a.globalUnreadsCountActions;
        this.store = store;
        this.selector = selector;
        this.chatroomsActions = chatroomsActions;
        this.globalUnreadsCountActions = globalUnreadsCountActions;
    }
    GlobalUnreadsCountApi.prototype.subscribeToGlobalUnreadsCount = function (_a) {
        var _this = this;
        var callback = _a.callback, filter = _a.filter;
        var _storeCallback = this._createStoreCallbackForUnreadsCount(callback);
        var isUnreadCountLoaded = this.selector.isUnreadCountLoaded(this.store.getState());
        if (!isUnreadCountLoaded) {
            ConnectivityService.waitForOnline.then(function () {
                _this.store.dispatch(_this.globalUnreadsCountActions.enable());
                _this.store.dispatch(_this.chatroomsActions.fetchUnreadsChatroomIds({ unreadChatroomLimit: config.maxTrackableUnreads + 1, filter: filter }));
            });
        }
        _storeCallback();
        var unsubscribe = this.store.subscribe(_storeCallback);
        return {
            unsubscribe: unsubscribe,
        };
    };
    GlobalUnreadsCountApi.prototype._createStoreCallbackForUnreadsCount = function (userCallback) {
        var _this = this;
        var _unreadsCount;
        return function () {
            var state = _this.store.getState();
            var unreadsCount = _this.selector.getCount(state);
            var isUnreadCountLoaded = _this.selector.isUnreadCountLoaded(state);
            if (!isUnreadCountLoaded) {
                return;
            }
            if (_unreadsCount === undefined || _unreadsCount.count !== unreadsCount.count || _unreadsCount.overflow !== unreadsCount.overflow) {
                _unreadsCount = unreadsCount;
                userCallback(_unreadsCount);
            }
        };
    };
    return GlobalUnreadsCountApi;
}());
export { GlobalUnreadsCountApi };
